import {gql} from '@apollo/client';

export const notificationMutations = {
    CHANGE_NOTIFICATION_STATUS: gql`
        mutation ChangeNotificationStatus($ids: [UUID!]!, $status: NotificationStatus!) {
            changeNotificationStatus(ids: $ids, status: $status) {
                message
                data
                statusCode
                success
            }
        }
    `,
};
